import React, { useState } from "react";
import "./Newsletter.css";

const BREVO_ENDPOINT ="https://fd0f5108.sibforms.com/serve/MUIFABiqUSgaPJ8THSqu76WwJi4fVf7ixd0HBIQII5-cMQgASwc7BLkQ0pOe2mDSZbXZqQH7tzu6I11MfCyCQCAUZOLWOnPtTK95IOZfTo-EBmb83UcES46JJiqGyiCCEJww0EN8oZyRLbPCdxwAqeuiLlrrAXJ1TKlSdMKXFZfi4C4wnvMDzeN5SKjQdPD1gexCfqImtiUCTWAT";

const NewsletterForm = () => {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const formData = new FormData(e.target);

    try {
      const res = await fetch(BREVO_ENDPOINT, {
        method: "POST",
        body: formData,
        mode:"no-cors"
      
      });
console.log(res)

      setSubmitted(true);
      // setTimeout(() => setSubmitted(false), 5000);
      e.target.reset();
    } catch (err) {
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="newsletter-section">
      <div className="newsletter-card">
        {submitted ? (
          <div className="newsletter-success">
            <h4>You're subscribed </h4>
            <p className="confirmation_text">Please check your inbox to confirm.</p>
          </div>
        ) : (
          <>
            <header className="newsletter-header">
              <h4>Newsletter</h4>
              <p>Subscribe to stay updated with our latest work.</p>
            </header>

            <form className="newsletter-form" onSubmit={handleSubmit}>
              <input
                type="email"
                name="EMAIL"
                placeholder="Your email address"
                required
              />

              <button type="submit" disabled={loading}>
                {loading ? "Subscribing…" : "Subscribe"}
              </button>

              {error && <p className="newsletter-error">{error}</p>}

              {/* Required Brevo fields */}
              <input type="hidden" name="locale" value="en" />
              <input type="hidden" name="html_type" value="simple" />
            </form>
          </>
        )}
      </div>
    </section>
  );
};

export default NewsletterForm;